/**
 * Список ID категорій для секції на головній (порядок і склад).
 * labelKey — ключ i18n для назви категорії (переклад в UI через t(labelKey)).
 */
export interface LandingCategoryItem {
  id: string
  labelKey: string
  bgColor: string
  image: string
  imageMobile: string
  imageAlt: string
  imageMobileAlt: string
}

export const LANDING_CATEGORY_IDS: LandingCategoryItem[] = [
  {
    id: 'biblical',
    labelKey: 'categories.Bible',
    bgColor: '#E8F4FF',
    image: '/assets/images/home-page/category/desktop/bibliia-knyha-koronari-shkiariana-paliturka.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/vidkryta-knyha-bibliia-na-blakytnomu-foni-banner.jpg',
    imageAlt: 'Книга Біблія у бордовій шкіряній обкладинці з золотим тисненням на блакитному фоні',
    imageMobileAlt: 'Широкий банер: відкрита книга Біблія з великим вільним блакитним простором зліва',
  },
  {
    id: 'family',
    labelKey: 'categories.Family',
    bgColor: '#FFEEE5',
    image: '/assets/images/home-page/category/desktop/shchaslyva-simia-tato-mama-dytyna.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/shchaslyva-simia-tato-mama-dytyna-banner.jpg',
    imageAlt: 'Щаслива молода сімʼя обіймається та посміхається: тато, мама і донька',
    imageMobileAlt: 'Широкий банер: щаслива молода сімʼя обіймається на світлому фоні з вільним місцем зліва',
  },
  {
    id: 'health',
    labelKey: 'categories.Health',
    bgColor: '#E5FFF5',
    image: '/assets/images/home-page/category/desktop/zdorove-kharchuvannia-salat-smuzi-hanteli.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/zdorove-kharchuvannia-salat-smuzi-hanteli-banner.jpg',
    imageAlt: 'Корисний сніданок із салатом, зелений смузі та гантелі з вимірювальною стрічкою як символ здорового способу життя',
    imageMobileAlt: 'Горизонтальний банер: здорове харчування, салат і смузі з великим зеленим фоном зліва',
  },
  {
    id: 'womens',
    labelKey: 'categories.Womens',
    bgColor: '#FFE5F0',
    image: '/assets/images/home-page/category/desktop/moloda-divchyna-v-dzhynsovii-sorochtsi.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/moloda-divchyna-v-dzhynsovii-sorochtsi-banner.jpg',
    imageAlt: 'Молода дівчина з русявим волоссям у джинсовій сорочці впевнено дивиться в кадр',
    imageMobileAlt: 'Широкий банер: портрет молодої дівчини у джинсовій сорочці з вільним рожевим місцем зліва',
  },
  {
    id: 'youth',
    labelKey: 'categories.Youth',
    bgColor: '#FFF5E5',
    image: '/assets/images/home-page/category/desktop/moloda-para-khlopets-divchyna-jest-klas.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/moloda-para-khlopets-divchyna-jest-klas-banner.jpg',
    imageAlt: 'Молода усміхнена пара обіймається та показує жест клас пальцем угору',
    imageMobileAlt: 'Горизонтальний банер: молода пара показує жест клас із вільним простором для заголовка зліва',
  },
  {
    id: 'teenage',
    labelKey: 'categories.Teenage',
    bgColor: '#FFFBE5',
    image: '/assets/images/home-page/category/desktop/hrupa-shchaslyvykh-pidlitkiv-druzi-posmishky.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/hrupa-shchaslyvykh-pidlitkiv-druzi-posmishky-banner.jpg',
    imageAlt: 'Група веселих молодих людей та підлітків обіймаються і щиро посміхаються',
    imageMobileAlt: 'Горизонтальний банер: група усміхнених підлітків та друзів із вільним жовтим фоном зліва',
  },
  {
    id: 'childish',
    labelKey: 'categories.Childish',
    bgColor: '#F0E5FF',
    image: '/assets/images/home-page/category/desktop/divchynka-pokazuie-sertse-rukamy.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/divchynka-pokazuie-sertse-rukamy-banner.jpg',
    imageAlt: 'Усміхнена дівчинка з рожевим обручем показує жест серця руками',
    imageMobileAlt: 'Широкий банер: усміхнена дівчинка показує жест серця руками з вільним простором для тексту зліва',
  },
  {
    id: 'psychology',
    labelKey: 'categories.Psychology',
    bgColor: '#FFE5F0',
    image: '/assets/images/home-page/category/desktop/mentalne-zdorovya-divchyna-kvitkove-volossia.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/mentalne-zdorovya-divchyna-kvitkove-volossia-banner.jpg',
    imageAlt: 'Жіночий профіль з яскравими різнокольоровими квітами у волоссі на фіолетовому фоні',
    imageMobileAlt: 'Горизонтальний банер: жіночий профіль із квітами у волоссі та вільним фіолетовим фоном зліва',
  },
  {
    id: 'prayer',
    labelKey: 'categories.Prayer',
    bgColor: '#E5FFF5',
    image: '/assets/images/home-page/category/desktop/cholovik-molytsia-zakryti-ochi-medytatsiia.jpg',
    imageMobile: '/assets/images/home-page/category/mobile/cholovik-molytsia-zakryti-ochi-medytatsiia-banner.jpg',
    imageAlt: 'Чоловік із закритими очима склав руки у молитві або медитації на світлому фоні',
    imageMobileAlt: 'Широкий банер: чоловік у молитві або медитації з великим вільним простором для тексту зліва',
  },
]
